export const MARVEL_CITATIONS = [
  {
    content: '"CONTRARY TO POPULAR BELIEF, I KNOW EXACTLY WHAT I’M DOING."',
    author: 'TONY STARK - Iron Man 2 (2010)'
  },
  {
    content: '"I CAN DO THIS ALL DAY." - STEVE ROGERS / CAPTAIN AMERICA',
    author: 'Captain America - The First Avenger (2011)'
  },
  {
    content: '"I\'VE BEEN FIGHTING WITH ONE ARM TIED BEHIND MY BACK, BUT WHAT HAPPENS WHEN I’M FINALLY SET FREE."',
    author: "Carol Danvers - Captain Marvel (2019)"
  },
  {
    content: '"WELL, I DON\'T JUDGE PEOPLE ON THEIR WORST MISTAKES."',
    author: 'Natasha Romanova - Avengers: Endgame (2019)'
  }
]